import { mapGetters } from 'vuex';
import WiseCompaniesAPI from '../../../../api/wiseCompanies';
import WiseUsersAPI from '../../../../api/wiseUsers';
import { FEATURE_FLAGS } from '../../../../featureFlags';

export default {
  data() {
    return {
      wiseCompanies: [],
      selectedWiseCompanies: [],
      wiseCompaniesLoading: false,
      wiseUsers: [],
      selectedWiseUser: null,
      wiseUsersLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
    }),
    wiseFeatureEnabled() {
      return this.isFeatureEnabledonAccount(
        this.currentAccountId,
        FEATURE_FLAGS.WISE
      );
    },
  },
  methods: {
    async fetchWiseCompanies() {
      if (!this.wiseFeatureEnabled) {
        return;
      }
      this.wiseCompaniesLoading = true;
      try {
        const { data } = await WiseCompaniesAPI.get();
        this.wiseCompanies = data.payload || [];
        this.hydrateSelectedWiseCompanies();
      } catch (error) {
        this.wiseCompanies = [];
      } finally {
        this.wiseCompaniesLoading = false;
      }
    },
    async fetchWiseUsers() {
      if (!this.wiseFeatureEnabled) {
        return;
      }
      this.wiseUsersLoading = true;
      try {
        const { data } = await WiseUsersAPI.get();
        this.wiseUsers = data.payload || [];
        if (
          this.permissionsSelected &&
          this.permissionsSelected.can_see_wise &&
          !this.permissionsSelected.can_use_wise
        ) {
          this.permissionsSelected.can_use_wise = true;
        }
        this.hydrateSelectedWiseUser();
      } catch (error) {
        this.wiseUsers = [];
      } finally {
        this.wiseUsersLoading = false;
      }
    },
    fetchWiseAccessOptions() {
      return Promise.all([this.fetchWiseUsers(), this.fetchWiseCompanies()]);
    },
    hydrateSelectedWiseCompanies() {
      const ids = (
        this.permissionsSelected.wise_company_ids ||
        this.agentPermissions?.wise_company_ids ||
        []
      ).map(String);
      this.selectedWiseCompanies = this.wiseCompanies.filter(company =>
        ids.includes(String(company.id))
      );
    },
    hydrateSelectedWiseUser() {
      const id = String(
        this.permissionsSelected.wise_user_id ||
          this.agentPermissions?.wise_user_id ||
          ''
      );
      this.selectedWiseUser =
        this.wiseUsers.find(user => String(user.id) === id) || null;
    },
    wiseUserLabel(user) {
      if (!user) {
        return '';
      }
      const name = user.name || '';
      const email = user.email || '';
      if (name && email) {
        return `${name} — ${email}`;
      }
      return name || email || user.id;
    },
    applyWisePermissions(permissions) {
      const canUse = !!this.permissionsSelected.can_use_wise;
      return {
        ...permissions,
        can_use_wise: canUse,
        can_see_wise: canUse,
        wise_user_id:
          canUse && this.selectedWiseUser
            ? String(this.selectedWiseUser.id)
            : '',
        wise_company_ids: canUse
          ? this.selectedWiseCompanies.map(company => String(company.id))
          : [],
      };
    },
    skipWisePermissionAutoFill(permission) {
      return [
        'can_use_wise',
        'can_see_wise',
        'wise_company_ids',
        'wise_user_id',
      ].includes(permission);
    },
  },
};
